import { useEffect } from 'react'
import {gaEvent} from 'shared'

export const NoResult = () => {
  useEffect(() => {
    const currentCategory = document.getElementById('category-selection')?.textContent
    const currentLocation = document.getElementById('location-selection')?.textContent
    const eventDetails = `Category: ${currentCategory} / Location: ${currentLocation}`
    gaEvent('engagement', 'pageload zero_results', eventDetails, null, true)
  }, [])

  return <div className="generic-no-results">
           {I18n.t('discover.categories.index.no_result_hint', {defaultValue: 'N/A'})}
         </div>
}
